import React from "react";
import Header from "./components/header";
import Cover from "./components/cover";
import About from "./components/about";
import Experience from "./components/experience";
import Skills from "./components/skills";
import Projects from "./components/projects";
import Contact from "./components/contact";
import Footer from "./components/footer";
import "./style.css";

// Prevent the browser from restoring a previous scroll position on
// refresh/back-forward navigation — always start fresh at the top.
if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

function App() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return React.createElement(
    "div",
    null,
    React.createElement(Header),
    React.createElement(Cover),
    React.createElement(About),
    React.createElement(Experience),
    React.createElement(Skills),
    React.createElement(Projects),
    React.createElement(Contact),
    React.createElement(Footer),
  );
}

export default App;
